import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { IProductTypeOverview } from '@cakeiteasy/web-utils';
import { CakeBuilderLink } from '../cake-builder-link';

import { getPickupAvailability, getDeliveryAvailability, getThirdPartyAvailability } from '../../../../helpers';

@Component({
  standalone: false,
  selector: 'cake-card-footer',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './cake-card-footer.component.html',
  styleUrls: ['./cake-card-footer.component.scss']
})
export class CakeCardFooterComponent extends CakeBuilderLink implements OnInit {
  @Input() cake: IProductTypeOverview;
  @Input() currency: string;
  @Input() showBakeryLine: boolean;
  @Input() bakeryOverviewUrl: string;
  @Input() isPriceVisible: boolean;

  @Output() onCakeNameClick = new EventEmitter<void>();
  @Output() onShowDelivery = new EventEmitter<void>();
  @Output() onShowPickup = new EventEmitter<void>();

  isPickUpAndDelivery: boolean;
  isPickUpOnly: boolean;
  isDeliveryOnly: boolean;
  isThirdPartyAvailable: boolean;

  ngOnInit() {
    super.ngOnInit();

    if (Boolean(this.cake.bakery)) {
      const isPickupAvailable = getPickupAvailability(this.cake);
      this.isThirdPartyAvailable = getThirdPartyAvailability(this.cake);
      const canBeDeliveredToDoor = getDeliveryAvailability(this.cake) || this.isThirdPartyAvailable;

      this.isPickUpAndDelivery = isPickupAvailable && canBeDeliveredToDoor;
      this.isPickUpOnly = isPickupAvailable && !canBeDeliveredToDoor;
      this.isDeliveryOnly = !isPickupAvailable && canBeDeliveredToDoor;
    }
  }

  public showPickup() {
    this.onShowPickup.emit();
  }

  public showDelivery() {
    this.onShowDelivery.emit();
  }
}
